import { environment } from 'environments';
import {
  convertImperialToMetricHeight,
  convertImperialToMetricWeight,
  convertMetricToImperialWeight,
  convertMetricToImperialHeight,
} from '@shared-utils';

class PhotosTabController {
  constructor($scope, Orders, Utils, QuestionnaireService, Constants) {
    'ngInject';

    Object.assign(this, {
      Orders,
      Utils,
      QuestionnaireService,
      Constants,
      INCH_TO_CM_CONVERSION_RATE: 2.54,
    });
    $scope.$on('tab:selected:photos', () => this.init());
    $scope.$on('visit:loaded', () => this.init());
    this.isMultiPhotoTask = false;
    this.hasPhotoTask = false;
    this.activeTab = 0;
    this.environment = environment.constants.ENV;
    this.BOD_1220 = ['localhost', 'dev', 'qa', 'staging', 'production'].includes(this.environment);
  }

  $onInit() {
    this.init();
  }

  init() {
    this.isMultiPhotoTask = !!this.visit.getTask(this.Orders.TASKS.MULTI_PHOTO);
    this.hasPhotoTask = this.visit.order_lines[0].stages[0].tasks.some(({ type }) =>
      [this.Orders.TASKS.MULTI_PHOTO, this.Orders.TASKS.ID_PHOTO, this.Orders.TASKS.EXAM_PHOTO].includes(type),
    );

    this.loading = true;
    this.Orders.getResponses()
      .then(({ data }) => {
        this.error = null;
        this.answers = data.answers;
        this.bmi = 0;
        this.stones = 0;
        this.pounds = 0;
        this.kilograms = 0;
        this.inches = 0;
        this.feet = 0;
        this.centimeters = 0;

        this.answers.forEach(answer => {
          if (
            [
              'bmi',
              'bmi_weight',
              'bmi_cocp_nor',
              'bmi_pde_pro',
              'bmi_map_lev1',
              'bmi_map_lev2',
              'bmi_map_uli',
              'bmi_wei',
              'bmi_meno',
              'bmi_wei_r',
            ].includes(answer.question.type)
          ) {
            this.bmi = this.calculateBMI(answer.value.height, answer.value.weight, answer.value.system);
          }

          if (answer.value.system === 'imperial') {
            this.imperialHeight = convertImperialToMetricHeight(answer.value.height);
            this.stones = Math.floor(answer.value.weight / 14);
            this.pounds = Math.round(answer.value.weight % 14);
            this.kilograms = convertImperialToMetricWeight(this.stones, this.pounds);
            this.centimeters = Math.round(answer.value.height * this.INCH_TO_CM_CONVERSION_RATE);
          }

          if (answer.value.system === 'metric') {
            this.centimeters = Math.round(answer.value.height);
            this.kilograms = Math.round(answer.value.weight);
            const { stones, pounds } = convertMetricToImperialWeight(answer.value.weight);
            this.stones = stones;
            this.pounds = pounds;
            this.imperialHeight = convertMetricToImperialHeight(this.centimeters);
          }
        });
      })
      .catch(err => {
        if (err.status === 404) {
          this.error = 'No questionnaire uploaded';
        } else {
          this.error = 'Could not load questionnaire';
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  replaceDotForDash(warning_level) {
    return this.Utils.replaceDotForDash(warning_level);
  }

  calculateBMI(height, weight, system) {
    let bmi;
    if (system === 'metric') {
      bmi = (weight / (height * height)) * 10000;
    } else {
      bmi = (703 * weight) / (height * height);
    }

    return bmi.toFixed(1);
  }
}

PhotosTabController.$inject = ['$scope', 'Orders', 'Utils', 'QuestionnaireService', 'Constants'];
angular.module('pims').component('visitPhotos', {
  templateUrl: 'app/views/visits/detail/sections/photos/photos.html',
  controller: PhotosTabController,
  controllerAs: 'vm',
  bindings: {
    visit: '=',
    active: '=',
  },
});
